var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPacket(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 60",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 53V37.5L16 30m0 23V38.7M40 53V37.5L64 30m0 23V38.7",
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25.5L16 30l-4 7.5 23.5 8 4.5-8m12-12L64 30l4 7.5-23.5 8-4.5-8",
    stroke: "#000",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 17,
    r: 10,
    stroke: "#000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 16.5l3.3 3.5 6.2-7",
    stroke: "#000",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacket);
export default "/_next/static/images/5bc5d2975dab8b8f81e53dc3152ec246.svg";
export { ForwardRef as ReactComponent };